import {
  Instant,
  type LocalDate,
  type LocalDateTime,
  ZoneId,
} from "@js-joda/core";

/**
 * Convert to Instant
 * @param timeString
 * @constructor
 */
export function ConvertToInstant(timeString: string): Instant {
  if (!timeString) {
    return undefined;
  }
  return Instant.parse(timeString);
}

/**
 * Convert to Local Date Time
 * @param timeString time string
 * @constructor
 */
export function convertInstantStringToLocalDateTime(
  timeString: string,
): LocalDateTime {
  return Instant.parse(timeString).atZone(ZoneId.UTC).toLocalDateTime();
}

export function convertLocalDateTimeToInstantString(
  localDateTime: LocalDateTime,
): string {
  return localDateTime.atZone(ZoneId.UTC).toInstant().toString();
}

export function LocalDateTimeToDate(localDateTime: LocalDateTime): Date {
  // Create a time string.
  let timeString = localDateTime.atZone(ZoneId.UTC).toString();
  // Remove the last "Z"
  timeString = timeString.substring(0, timeString.length - 1);
  return new Date(timeString);
}

export function DateToLocalDateTime(date: Date): LocalDateTime {
  return Instant.parse(date.toISOString())
    .atZone(ZoneId.SYSTEM)
    .toLocalDateTime();
}

export function LocalDateToDate(localDate: LocalDate): Date {
  return LocalDateTimeToDate(localDate.atStartOfDay());
}

export function DateToLocalDate(date: Date): LocalDate {
  return DateToLocalDateTime(date).toLocalDate();
}
